module.exports = __webpack_public_path__ + "img/logo_full2.ed184c99.svg";